import SearchFilterSection from '@/ui/components/searchFilterSection/SearchFilterSection'

interface IssuesFiltersProps {
    search: string
    handleSearch: (value: string) => void
    clearFilters: () => void
    allItems?: any[]
    filteredItems?: any[]
    onFilterChange?: (type: any, selectedOptions: any) => void
    getFilterOptions?: (filterType: any) => any
    filterConfig?: any
    activeFilters?: any[]
    onFilterRemove?: (filterData: {
        filterName: string
        filters: any[]
    }) => void
    onFilterClick?: (filterData: { filterName: string; filters: any[] }) => void
    searchPlaceholder?: string
    itemLabel?: string
    showFilterPopup?: boolean
}

const IssuesFilters = ({
    search,
    handleSearch,
    clearFilters,
    allItems = [],
    filteredItems = [],
    onFilterChange = () => {},
    getFilterOptions = () => ({}),
    filterConfig = {},
    activeFilters = [],
    onFilterRemove,
    onFilterClick,
    searchPlaceholder = 'Search issues...',
    itemLabel = 'issues',
    showFilterPopup = true,
}: IssuesFiltersProps) => {
    return (
        <SearchFilterSection
            allItems={allItems}
            filteredItems={filteredItems}
            onSearchChange={handleSearch}
            onFilterChange={onFilterChange}
            getFilterOptions={getFilterOptions}
            filterConfig={filterConfig}
            searchValue={search}
            activeFilters={activeFilters}
            onFilterClick={onFilterClick}
            onFilterReset={clearFilters}
            searchPlaceholder={searchPlaceholder}
            itemLabel={itemLabel}
            showFilterPopup={showFilterPopup}
        />
    )
}

export default IssuesFilters
